import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';
import WebVitalChart from '../shared/WebVitalChart';

export default function CumulativeLayoutShiftSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result.score && (
                    <WebVitalChart
                        markerAt={parseFloat(result.score.toFixed(4))}
                        maxGoodVal={0.1}
                        minPoorVal={0.25}
                    />
                )}

                {result.largest_entry && (
                    <div className={`result-meta ${result.status}`}>
                        <div className="title">DOM element which contributes the most to CLS score:</div>

                        {result.largest_entry.text && (
                            <div>
                                <strong>Text: </strong>
                                {result.largest_entry.text}
                            </div>
                        )}

                        <div>
                            <strong>Html: </strong>
                            <em dangerouslySetInnerHTML={{ __html: result.largest_entry.node }} />
                        </div>
                        <div>
                            <strong>Score: </strong> {result.largest_entry.score}
                        </div>
                    </div>
                )}

                {result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}
